import React from 'react'
import {Box,Typography,Stack} from '@mui/material'
import ExerciseCard from './ExerciseCard'

const SimilarExercises = ({targetMuscleExercise,equipmentExercise}) => {
  if(targetMuscleExercise.length === 0){
    return (<h1>Loading Some More Exercises...</h1>)
  }

  
  return (
    <Box>
    <Box sx={{marginTop:{lg:"100px" ,sx:"20px"},flexDirection:'row'}} p="20px">
    <Typography variant='h4' mb='33px'>
           Exercises that target same muscle group
    </Typography>
    <Stack justifyContent="flex-start" flexWrap="wrap" alignItems="center"
      sx={{
        flexDirection :{lg:'row'},
        gap:{lg:'110px',xs:'0'}
      }}
    >
     {targetMuscleExercise?.slice(0,3).map((exercise,index)=>(
       <ExerciseCard key={index} exercise={exercise}/>
     ))}
    </Stack>
  </Box>
  <Box sx={{marginTop:{lg:"100px" ,sx:"20px"},flexDirection:'row'}} p="20px">
    <Typography variant='h4' mb='33px'>
           Exercises that uses same equipment
    </Typography>
    <Stack justifyContent="flex-start" flexWrap="wrap" alignItems="center"
      sx={{
        flexDirection :{lg:'row'},
        gap:{lg:'110px',xs:'0'}
      }}
    >
     {equipmentExercise?.slice(0,3).map((exercise,index)=>(
       <ExerciseCard key={index} exercise={exercise}/>
     ))}
    </Stack>
  </Box>
  </Box>
  )
}

export default SimilarExercises